export const TASK_STATUS_ALL = {
  Planned: 'planned',
  Submitted: 'submitted',
  Rejected: 'rejected',
  Approved: 'approved',
  ['Not Applicable']: 'not applicable',
  ['In Progress']: 'in_progress',
  Done: 'done',
}

export const TASK_STATUS = {
  plan_submit_approve_reject_type: {
    Planned: 'planned',
    Submitted: 'submitted',
    Rejected: 'rejected',
    Approved: 'approved',
    ['Not Applicable']: 'not applicable',
  },
  plan_pass_fail_type: {
    Planned: 'planned',
    Pass: 'pass',
    Fail: 'fail',
    ['Not Applicable']: 'not applicable',
  },
  percentage_progress_type: {
    Planned: 'planned',
  },
  plan_inprogress_done_type: {
    Planned: 'planned',
    ['In Progress']: 'in_progress',
    Done: 'done',
    ['Not Applicable']: 'not applicable',
  },
}

export const TASK_STATUS_UPDATER = {
  plan_submit_approve_reject_type: {
    Planned: 'planned',
    Submitted: 'submitted',
  },
  plan_pass_fail_type: {
    Planned: 'planned',
    Pass: 'pass',
    Fail: 'fail',
    ['Not Applicable']: 'not applicable',
  },
  percentage_progress_type: {
    Planned: 'planned',
  },
  plan_inprogress_done_type: {
    Planned: 'planned',
    ['In Progress']: 'in_progress',
    Done: 'done',
    ['Not Applicable']: 'not applicable',
  },
}
